import HiddenNav from "../classes/HiddenNav";

export const initDivSiteSubmenu = () => {
    const siteSubmenu = document.querySelector(`div.site-submenu nav`);

    if ( siteSubmenu )
    {
        document.body.classList.add( 'with-submenu' );
		
		const header = document.querySelector(`header`);
        const list = siteSubmenu.querySelector(`ul`);
        const hiddenNavInstance = new HiddenNav( list );
        hiddenNavInstance.init( window.innerWidth >= 956 );

        window.addEventListener( `resize`, () => {
            if ( window.innerWidth >= 956 && !hiddenNavInstance.isHiding() )
            {
                hiddenNavInstance.startHiding();
            }

            if ( window.innerWidth < 956 && hiddenNavInstance.isHiding() )
            {
                hiddenNavInstance.stopHiding();
            }
        } );

         window.addEventListener(`scroll`, () => {
             const parentPosition = siteSubmenu.parentElement.getBoundingClientRect();
             const isFixed = header.classList.contains(`show`) ? parentPosition.top - header.offsetHeight <= 0 && window.pageYOffset > 0 : parentPosition.top <= 0;

             isFixed ? siteSubmenu.classList.add(`fixed`) : siteSubmenu.classList.remove(`fixed`);
         });

		const apartmentsLink = siteSubmenu.querySelector( 'a[href*="/apartments/"]' );

		if ( !apartmentsLink )
		{
			return;
		}

		const handleLink = () => {
			if ( window.innerWidth < 956 && !/param/.test( apartmentsLink.href ) )
			{
				apartmentsLink.href = apartmentsLink.href.replace( '/apartments/', '/apartments/?type=param' );
			}
			else if ( window.innerWidth >= 956 )
			{
				apartmentsLink.href = apartmentsLink.href.replace( '/apartments/?type=param', '/apartments/' );
			}
		};

		handleLink();
		window.addEventListener( 'resize', handleLink );
    }
};